import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Truck, ShieldCheck, Leaf } from 'lucide-react';
export function CtaSection() {
  const ctaLink = 'https://hunderunde.shop/products/futtertopping-magen-darm';
  return <section className="w-full py-20 px-4 md:px-8 text-center relative overflow-hidden" data-id="element-12">
      {/* Decorative background circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-sage/30 rounded-full blur-3xl -z-10" data-id="element-13"></div>

      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-15">
          <h2 className="font-handwritten text-4xl md:text-6xl text-forestGreen font-bold mb-6" data-id="element-16">
            Schau nicht auf die Pfoten – schau auf den Darm
          </h2>

          <p className="font-serif text-lg md:text-xl text-gray-800 mb-10 max-w-2xl mx-auto" data-id="element-17">
            Teste das Magen-Darm-Topping jetzt risikofrei – mit
            Geld-zurück-Garantie.
          </p>

          <a href={ctaLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-forestGreen text-white font-serif font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group" data-id="element-18">
            Jetzt für meinen Hund entdecken
            <ArrowRight className="group-hover:translate-x-1 transition-transform" data-id="element-19" />
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-8 text-sm font-serif text-warmBrown/80" data-id="element-20">
            <span className="flex items-center gap-1.5" data-id="element-21">
              <Truck size={16} className="text-forestGreen" data-id="element-22" /> Schneller Versand
            </span>
            <span className="flex items-center gap-1.5" data-id="element-23">
              <ShieldCheck size={16} className="text-forestGreen" data-id="element-24" />{' '}
              Zufriedenheitsgarantie
            </span>
            <span className="flex items-center gap-1.5" data-id="element-25">
              <Leaf size={16} className="text-forestGreen" data-id="element-26" /> 100% Natürliche
              Inhaltsstoffe
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}